import React from 'react';
import Joi from 'joi';
import { api as apiRequest } from '@culture/common-helpers/request';

import Template from 'pageTemplates/bid';

const BidPage = (props) => <Template {...props} />;

const getRubricPage = (cleanCache) =>
	apiRequest('rubricPages/page', {
		rubricPath: 'bid',
		cleanCache
	});

export async function getServerSideProps({ query }) {
	const validationSchema = Joi.object().keys({
		cleanCache: Joi.boolean().failover(false)
	});

	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const rubricPage = await getRubricPage(params?.cleanCache);

	return {
		props: {
			text: rubricPage?.text || null,
			revalidate: true
		}
	};
}

export default BidPage;
